import React, { useEffect, useState } from "react";

import {
  Text,
  Toast,
  Input,
  Picker,
  EditModal,
  ConfirmAlert,
  GroupInfoBox,
  AddItemButton,
  DeleteAlertComponent,
} from "components";

import { useFlag } from "hooks";
import { changeArrayAt } from "utils";
import { colors, sizes, strings } from "assets/constants";

import { useCustomerPhonesTypes } from "clients/apis";
import { PhoneTypesIcons } from "assets/data";
import css from "styles";
import { View } from "react-native";

export default function Phones(props: {
  phones: PhoneT[];
  onChange: (phones: PhoneT[]) => void;
  disabled?: boolean;
}) {
  const { data: phonesTypes } = useCustomerPhonesTypes();

  const { phones, onChange, disabled } = props;
  const [itemsState, setItemsState] = useState<Array<PhoneT>>(phones);
  useEffect(() => {
    setItemsState(phones);
  }, [phones]);

  const [indexToEdit, setIndexToEdit] = useState<number | null>(null);
  const { flg: modal, on: showModal, off: hideModal } = useFlag();
  const { flg: alert, on: showAlert, off: hideAlert } = useFlag();

  const [fields, setFields] = useState<PhoneT>();
  const updateFields = (newVal: PhoneT) =>
    setFields((prev) => ({ ...prev, ...newVal }));

  const _onChangeType = (type?: TypeT) => updateFields({ type });
  const _onChangeNumber = (number: string) => updateFields({ number });

  const resetForm = () => {
    setIndexToEdit(null);
    setFields({});
  };

  const _onAdd = () => {
    fields && onChange(phones ? [...phones, fields] : [fields]);
    resetForm();
  };

  const _onEdit = () => {
    const tmp =
      typeof indexToEdit === "number" &&
      changeArrayAt(itemsState, indexToEdit, fields);
    tmp && onChange(tmp);
  };

  const _onDelete = (close: () => void) => {
    const tmp =
      typeof indexToEdit === "number" && changeArrayAt(itemsState, indexToEdit);
    tmp && onChange(tmp);
    resetForm();
    close();
  };

  const _onConfirm = () => {
    if (!fields?.type || !fields.number) {
      Toast.error({ message: strings.fill_all_fields });
      return;
    }
    indexToEdit === null ? _onAdd() : _onEdit();
    resetForm();
    hideModal();
  };

  const _onCancel = () => {
    resetForm();
    hideModal();
  };

  return (
    <>
      <View style={css.responsiveListContainer}>
        {itemsState?.length > 0 ? (
          itemsState?.map((phone: PhoneT, key: number) => {
            return (
              <View key={String(key)} style={css.responsiveBoxContainer}>
                <GroupInfoBox
                  disabled={disabled}
                  key={String(key)}
                  onEdit={() => {
                    setIndexToEdit(key);
                    setFields(phone);
                    showModal();
                  }}
                  onDelete={() => {
                    setIndexToEdit(key);
                    showAlert();
                  }}
                  title={phone?.type?.title}
                  icon={{
                    name: phone?.type?.id
                      ? PhoneTypesIcons?.[phone?.type?.id]
                      : "phone",
                  }}
                  renderContent={() => (
                    <>
                      <Text style={{ lineHeight: 22 }}>{phone.number}</Text>
                    </>
                  )}
                />
              </View>
            );
          })
        ) : (
          <Text
            size="sm"
            color={colors.textColorGray}
            style={{ marginBottom: sizes.space / 2 }}
          >
            {strings.no_customer_phone}
          </Text>
        )}
      </View>

      {!disabled && (
        <AddItemButton onPress={showModal} title={strings.add_new_phone} />
      )}

      <EditModal
        visible={modal}
        onCancel={_onCancel}
        onConfirm={_onConfirm}
        renderForm={() => {
          return (
            <>
              {phonesTypes?.data && (
                <Picker
                  onSelect={_onChangeType}
                  data={phonesTypes?.data}
                  value={fields?.type?.title}
                  placeholder={strings.pick_phone_type}
                  icon={{ name: "airplay" }}
                />
              )}

              <Input
                onChangeText={_onChangeNumber}
                value={fields?.number}
                placeholder={strings.insert_phone_number}
                icon={{ name: "phone" }}
                keyboardType="phone-pad"
              />
            </>
          );
        }}
      />

      <ConfirmAlert
        force
        show={alert}
        hide={hideAlert}
        renderContent={(close) => (
          <DeleteAlertComponent
            removeLoading={false}
            remove={() => _onDelete(close)}
            cancel={close}
          />
        )}
      />
    </>
  );
}
